import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=776851a0&scoped=true&"
import script from "./Shape.vue?vue&type=script&lang=js&"
export * from "./Shape.vue?vue&type=script&lang=js&"
import style0 from "./Shape.vue?vue&type=style&index=0&id=776851a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776851a0",
  null
  
)

export default component.exports